module.exports = __webpack_public_path__ + "static/media/corn.75a6b8d5.png";